var app = angular.module('leonardo');

var FormPrice = function() {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      maxlength: '=ngMaxLength',
      minlength: '=ngMinlength',
      blur: '&ngBlur',
      focus: '&ngFocus',
      onSubmit: '&',
      label: '@',
      placeholder: '@',
      symbol: '@',
      fractionSize: '=?'
    },
    templateUrl: 'views/templates/form/form-price.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];

      scope.getDecimals = function (value) {
        let decimalsArray = value ? value.toString().split('.') : [];
        let decimals = 100;
        if (decimalsArray.length > 1){
          decimals = Math.pow(10, decimalsArray[1].length);
        }
        return decimals;
      }

      scope.$watch('value', function (value) {
        value = !isNull(value) ? value.replace(/[$,]/g, '') : '0';
        scope.ngModelCtrl.$setViewValue(Number(value)*scope.getDecimals(value));
      });

      scope.ngModelCtrl.$render = function () {
        var num = parseFloat(scope.ngModelCtrl.$viewValue)/scope.getDecimals(scope.ngModelCtrl.$viewValue);
        scope.value = !isNull(num) ? num.toString() : '';
      };

      element.find('input').bind("keydown keypress", function (e) {
        if (e.keyCode === 13) {
          scope.$apply(function () {
            scope.onSubmit();
          });
          e.preventDefault();
        }
      });
    }
  };
};

app.directive('formPrice', [FormPrice]);
